export default "__VITE_ASSET__rTI3Q2GG__"